import { Chip, Typography, styled } from "@mui/material";

import { ELLIPSIS_SX } from "@app/common/styles";

import { Row } from "@rui/Stack";

export const SearchChip = styled(Chip)(({ theme }) => ({
  backgroundColor: "#fff",
  borderRadius: "4px",
  fontSize: "12px",
  height: "24px",
  margin: theme.spacing(0, 0.25),
  borderColor: theme.palette.shades.neutral[100],
  "& .MuiChip-icon": {
    backgroundColor: theme.palette.shades.primary[500],
    borderRadius: "3px",
    color: "#fff",
    height: "18px",
    width: "18px",
    padding: theme.spacing(0.25),
  },
  "& .MuiChip-label": {
    maxWidth: "100px",
    paddingRight: "0",
    ...ELLIPSIS_SX,
  },
  "& .search_chip__delete_icon": {
    padding: "0px",
    margin: "0px",
  },
  "&:last-of-type": {
    marginRight: theme.spacing(0.75),
  },
}));

export const SearchTipRow = styled(Row)(({ theme }) => ({
  backgroundColor: theme.palette.transparent.black[2],
  borderRadius: "4px",
  padding: theme.spacing(0.5, 1),
}));

export interface SearchTipProps {
  keyword: string;
  label: string;
  example: string;
}

export const SearchTip = ({ keyword, label, example }: SearchTipProps) => {
  return (
    <SearchTipRow variant="apart">
      <Row variant="left" spacing={2}>
        <Row sx={{ width: "40px" }}>
          <Typography
            variant="bodySecondaryReg"
            sx={{
              backgroundColor: "transparent.black.8",
              padding: 0.5,
              borderRadius: "4px",
            }}
          >
            {keyword}
          </Typography>
        </Row>

        <Typography
          variant="bodySecondaryReg"
          sx={{ color: "shades.neutral.700" }}
        >
          {label}
        </Typography>
      </Row>
      <Typography
        variant="bodySecondaryReg"
        sx={{ color: "shades.neutral.400" }}
      >
        {example}
      </Typography>
    </SearchTipRow>
  );
};
